import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { Field } from 'redux-form';

const LOCALE_PREFIX = 'GB/components/FinancialInfo/FinancialInfo';

export class EmploymentStatus extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        employmentStatusListOptions: PropTypes.object.isRequired,
        financialInfo: PropTypes.object.isRequired
    };

    render() {
        const { intl, employmentStatusListOptions, financialInfo } = this.props;

        return (
            <Field
                id="employmentStatus"
                name="employmentStatus"
                component={SelectField}
                optionList={mapOptionsToSelectField(employmentStatusListOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.employmentStatus`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.employmentStatus`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.employmentStatus-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    employmentStatusListOptions: _.get(state, `serverData.messages[${LOCALE_PREFIX}].applyForBmlUK.employmentStatusTypes`),
    financialInfo: _.get(state, 'form.ppcreditapply.values.financial-info')
});

export default connect(mapStateToProps)(injectIntl(EmploymentStatus));
